import React from "react";
import EventList from './EventList';
import { withRouter } from "react-router-dom";
import { Row, Col } from 'antd';
import axios from "axios";
import { withTranslation } from 'react-i18next';

class EventView extends React.Component {
    state = ({
        data: [],
        loading: true,
        pagination: {
            current: 1,
            total: 100,
            pageSize: 10,
        },
        searchText: '',
        sortedInfo: { sortOrder: undefined, sortField: undefined },
    })

    componentWillMount() {
        let token = localStorage.getItem('token');
        axios.defaults.xsrfCookieName = 'csrftoken'
        axios.defaults.xsrfHeaderName = "X_CSRFTOKEN"
        axios.defaults.headers = {
            "Content-Type": "application/json",
            "Accept-Language": localStorage.getItem('language'),
            Authorization: `Token ${token}`,
        };
        this.fetch();
    }

    handleState = (key, value) => {
        let obj = {}
        obj[key] = value;
        this.setState(obj);
    }

    fetch = (params = {}) => {
        this.setState({ loading: true });

        let search = this.state.searchText;
        if (params.search !== undefined && params.search !== this.state.searchText)
            search = params.search;

        let sortOrder = '';
        if (params.sortOrder === 'descend')
            sortOrder = '-';

        let ordering;
        if (params.sortField && params.sortOrder !== undefined)
            ordering = sortOrder + params.sortField

        if (!params.page)
            params.page = this.state.pagination.current;
        axios({
            url: process.env.REACT_APP_AXIOS_URL + "/api/events/",
            method: 'get',
            params: {
                page: params.page,
                search: search,
                ordering: ordering
            },
        }).then(res => {
            const pagination = { ...this.state.pagination };
            pagination.total = res.data.count;
            pagination.current = params.page;
            this.setState({
                loading: false,
                data: res.data.results,
                pagination: pagination,
            });
        });
    };

    render() {
        return (
            <Row>
                {/* <Col span={3}>
                    <EventSidebar fetch={this.fetch} />
                </Col> */}
                <Col span={24}>
                    <EventList
                        data={this.state.data}
                        fetch={this.fetch}
                        loading={this.state.loading}
                        pagination={this.state.pagination}
                        handleState={this.handleState}
                        searchText={this.state.searchText}
                        sortedInfo={this.state.sortedInfo}
                    />
                </Col>
            </Row>
        )
    }
}

export default withRouter(withTranslation()(EventView));


// WEBPACK FOOTER //
// ./src/containers/Events/EventView.js